module.exports = __webpack_public_path__ + "img/dloons_06.aeb1c720.png";